// Psyque — Agencia Digital. Punto de entrada JS.
// Cada módulo sale pronto si no encuentra sus elementos y respeta las
// preferencias del usuario (movimiento reducido, puntero impreciso).
import { initSmartHeader } from "./modules/smart-header.js";
import { initNavigation } from "./modules/navigation.js";
import { initContactModal } from "./modules/contact-modal.js";
import { initReveal } from "./modules/reveal.js";
import { initScramble } from "./modules/scramble.js";
import { initCursorGlow } from "./modules/cursor-glow.js";
import { initBackgrounds } from "./modules/backgrounds.js";
import { initHome } from "./modules/home.js";

initSmartHeader();
initNavigation();
initContactModal();
initReveal();
initScramble();
initCursorGlow();
initBackgrounds();
initHome();
